import React from "react";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import GlobalStyles from "@mui/material/GlobalStyles";

import getGlobalStyles from "globalStyles";
import createAppTheme from "app/theme/createAppTheme";

const theme = createAppTheme();

const ThemeProvider = ({ children }) => (
  <MuiThemeProvider theme={theme}>
    <GlobalStyles styles={getGlobalStyles()} />
    {children}
  </MuiThemeProvider>
);

export default ThemeProvider;
